module.exports = __webpack_public_path__ + "img/error-404-background.72b3529.jpeg";